import { Checkbox, Form, Input, Modal } from 'antd';
import React, { useContext, useState } from 'react';
import { rootContext } from 'stores';
import './Craeteuser.scss';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 }
};
const AddUserRegion: React.FC<{
  addUserModal: boolean;
  setAddUserModal: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ addUserModal, setAddUserModal }) => {
  const {
    UsersRegions: {
      state: { data, ui },
      addUserRegions,
      getUserRegions
    }
  } = useContext(rootContext);
  const [createUserForm] = Form.useForm();
  const [isShippingAvailable, setIsShippingAvailable] = useState(false);

  return (
    <div className="CraeteuserStyles">
      <Modal
        visible={addUserModal}
        okText="Add"
        okButtonProps={{
          loading: ui.addUserLoading,
          onClick: () => createUserForm.submit()
        }}
        title="Create country origin"
        onCancel={() => {
          setAddUserModal(false);
          createUserForm.resetFields();
        }}
      >
        <Form
          {...layout}
          form={createUserForm}
          onFinish={async () => {
            const data1 = createUserForm.getFieldsValue();
            // return console.log(data);
            const success = await addUserRegions({
              name: data1.name,
              code: data1.code.toUpperCase(),
              is_shipping_available: isShippingAvailable
            });
            if (success) {
              createUserForm.resetFields();
              setAddUserModal(false);
              getUserRegions({
                ...data.getUserRegionsParams
              });
            }
          }}
        >
          <Form.Item
            label="Country Name"
            name="name"
            normalize={e => (/\s/.test(e) ? e.slice(0, -1) : e)}
            rules={[
              {
                required: true,
                whitespace: true,
                message: 'Please enter name!'
              }
            ]}
          >
            <Input
              name="country_name"
              placeholder="Enter country name "
              autoComplete="off"
            />
          </Form.Item>
          <Form.Item
            label="Country Code"
            name="code"
            normalize={e => (/\s/.test(e) ? e.slice(0, -1) : e)}
            rules={[
              {
                required: true,
                whitespace: true,
                message: 'Please enter code!'
              }
            ]}
          >
            <Input
              name="country_code"
              placeholder="Enter country code like US etc."
              autoComplete="off"
              maxLength={2}
            />
          </Form.Item>
          <Form.Item
            label="Shipping Available"
            tooltip="All regions will be considered."
            name="all_region"
          >
            <Checkbox
              value={isShippingAvailable}
              style={{ marginLeft: '10px' }}
              onChange={e => setIsShippingAvailable(e.target.checked)}
            ></Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUserRegion;
